<div class="logger-health-container">
  <!-- Success Banner -->
  <div class="alert alert-success success-banner" *ngIf="successMessage" role="alert">
    {{ successMessage }}
  </div>

  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-left">
      <div class="header-icon-tile">
        <svg *ngIf="showCustomerView" class="header-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
        </svg>
        <svg *ngIf="!showCustomerView" class="header-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="2" width="20" height="8" rx="2" ry="2"/>
          <rect x="2" y="14" width="20" height="8" rx="2" ry="2"/>
          <line x1="6" y1="6" x2="6.01" y2="6"/>
          <line x1="6" y1="18" x2="6.01" y2="18"/>
        </svg>
      </div>
      <div class="title-area">
        <h2>{{ showCustomerView ? 'Logger & Meter Health' : 'Global Support View' }}</h2>
        <p *ngIf="showCustomerView && currentSiteName">Live monitoring status for <strong>{{ currentSiteName }}</strong>.</p>
        <p *ngIf="showCustomerView && !currentSiteName">Live monitoring status for your site.</p>
        <p *ngIf="!showCustomerView">Operations console for ingestion health across all sites.</p>
      </div>
    </div>

    <!-- Header Actions: SuperAdmin View Switcher -->
    <div class="header-actions" *ngIf="isSuperAdmin">
      <div class="segmented-tabs">
        <button type="button" [class.active]="activeTab === 'MAINTENANCE'" (click)="switchTab('MAINTENANCE')">
          Maintenance View
        </button>
        <button type="button" [class.active]="activeTab === 'SUPPORT'" (click)="switchTab('SUPPORT')">
          Global Support View
        </button>
      </div>
    </div>

    <div class="header-right">
      <img src="assets/dcs_group_logo.png" alt="DCS Group" class="header-dcs-logo" />
      <button type="button" class="close-btn" (click)="close()" title="Close dialog" aria-label="Close dialog">&times;</button>
    </div>
  </div>

  <!-- Error Alert Banner -->
  <div class="error-banner" *ngIf="error">
    <svg class="banner-svg-icon" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
    </svg>
    <span>{{ error }}</span>
  </div>

  <!-- Loading State Spinner -->
  <div class="loader-wrapper" *ngIf="loading">
    <div class="spinner"></div>
    <span>Loading telemetry records...</span>
  </div>

  <!-- ========================================================================= -->
  <!-- 1. REDESIGNED CUSTOMER MAINTENANCE VIEW (SITE HEALTH COMMAND CENTRE)     -->
  <!-- ========================================================================= -->
  <div class="maintenance-view-container" *ngIf="!loading && !error && showCustomerView">
    <!-- Maintenance 4 Analytical KPI Metric Cards -->
    <div class="maintenance-kpis-grid">
      <!-- 1. TOTAL METERS CARD -->
      <div
        class="kpi-card kpi-total"
        [class.selected-filter]="activeFilterChip === 'ALL'"
        (click)="setFilterChip('ALL')"
        tabindex="0"
        (keydown.enter)="setFilterChip('ALL')"
        (keydown.space)="$event.preventDefault(); setFilterChip('ALL')"
        [attr.aria-label]="'Total meters: ' + (totalCount + staticCount)"
      >
        <div class="card-top-row">
          <div class="kpi-icon-wrap icon-total">
            <svg class="kpi-svg-icon" viewBox="0 0 20 20" fill="currentColor">
              <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"/>
            </svg>
          </div>
          <div class="kpi-title-block">
            <span class="kpi-label">Total meters</span>
            <span class="kpi-value">{{ totalCount + staticCount }}</span>
          </div>
        </div>

        <div class="card-bottom-row">
          <!-- Donut chart -->
          <div class="donut-chart-wrap" aria-hidden="true">
            <svg class="donut-svg" viewBox="0 0 44 44">
              <circle class="donut-bg" cx="22" cy="22" r="16" fill="none" stroke="#f2f4f7" stroke-width="7"/>
              <circle
                *ngFor="let seg of getMaintenanceResourceBreakdown()"
                class="donut-segment"
                cx="22"
                cy="22"
                r="16"
                fill="none"
                [attr.stroke]="seg.color"
                stroke-width="7"
                pathLength="100"
                [attr.stroke-dasharray]="seg.pct + ' ' + (100 - seg.pct)"
                [attr.stroke-dashoffset]="-seg.offset"
                transform="rotate(-90 22 22)"
              />
            </svg>
          </div>
          <!-- Legend list -->
          <div class="donut-legend">
            <div class="legend-item" *ngFor="let item of getMaintenanceResourceBreakdown()">
              <span class="legend-dot" [style.background-color]="item.color"></span>
              <span class="legend-label">{{ item.name }}</span>
              <span class="legend-count">{{ item.count }}</span>
            </div>
            <div class="legend-empty" *ngIf="getMaintenanceResourceBreakdown().length === 0">
              No meters configured
            </div>
          </div>
        </div>
      </div>

      <!-- 2. NEEDS ATTENTION CARD -->
      <div
        class="kpi-card kpi-warning"
        [class.selected-filter]="activeFilterChip === 'NEEDS_ATTENTION'"
        [class.has-issues]="warningCount > 0"
        (click)="setFilterChip('NEEDS_ATTENTION')"
        tabindex="0"
        (keydown.enter)="setFilterChip('NEEDS_ATTENTION')"
        (keydown.space)="$event.preventDefault(); setFilterChip('NEEDS_ATTENTION')"
        [attr.aria-label]="'Needs attention: ' + warningCount + ' meters'"
      >
        <div class="card-top-row">
          <div class="kpi-icon-wrap icon-warning">
            <svg class="kpi-svg-icon warn-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="kpi-title-block">
            <span class="kpi-label">Needs attention</span>
            <span class="kpi-value val-warning">{{ warningCount }}</span>
          </div>
        </div>

        <div class="card-bottom-row">
          <div class="status-bars-stack">
            <div class="status-bar-row" *ngFor="let row of getMaintenanceNeedsAttentionBreakdown()">
              <span class="status-bar-label">{{ row.label }}</span>
              <div class="status-bar-track" aria-hidden="true">
                <div class="status-bar-fill" [style.width.%]="row.pctOfMax" [style.background-color]="row.color"></div>
              </div>
              <span class="status-bar-count">{{ row.count }}</span>
            </div>
            <div class="status-bars-empty" *ngIf="getMaintenanceNeedsAttentionBreakdown().length === 0">
              <span class="healthy-text">All meters healthy</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 3. WORKING NORMALLY CARD -->
      <div
        class="kpi-card kpi-healthy"
        [class.selected-filter]="activeFilterChip === 'HEALTHY'"
        (click)="setFilterChip('HEALTHY')"
        tabindex="0"
        (keydown.enter)="setFilterChip('HEALTHY')"
        (keydown.space)="$event.preventDefault(); setFilterChip('HEALTHY')"
        [attr.aria-label]="'Working normally: ' + healthyCount + ' meters'"
      >
        <div class="card-top-row">
          <div class="kpi-icon-wrap icon-healthy">
            <svg class="kpi-svg-icon check-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="kpi-title-block">
            <span class="kpi-label">Working normally</span>
            <span class="kpi-value val-healthy">{{ healthyCount }}</span>
          </div>
        </div>

        <div class="card-bottom-row gauge-container">
          <div class="gauge-chart-wrap" aria-hidden="true">
            <svg class="gauge-svg" viewBox="0 0 84 46">
              <!-- Background semi-circle arc -->
              <path class="gauge-bg" d="M 10 42 A 32 32 0 0 1 74 42" fill="none" stroke="#dcfce7" stroke-width="7" stroke-linecap="round"/>
              <!-- Progress semi-circle arc -->
              <path
                *ngIf="healthyLivePercentage > 0"
                class="gauge-fill"
                d="M 10 42 A 32 32 0 0 1 74 42"
                fill="none"
                stroke="#16a34a"
                stroke-width="7"
                stroke-linecap="round"
                pathLength="100"
                [attr.stroke-dasharray]="healthyLivePercentage + ' 100'"
              />
            </svg>
            <div class="gauge-text-overlay">
              <span class="gauge-percentage">{{ healthyLivePercentage }}%</span>
              <span class="gauge-sub">{{ totalCount > 0 ? ('of ' + totalCount + ' live meters') : 'No live meters' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 4. STATIC & UTILITY CARD -->
      <div
        class="kpi-card kpi-static"
        [class.selected-filter]="activeFilterChip === 'STATIC'"
        (click)="setFilterChip('STATIC')"
        tabindex="0"
        (keydown.enter)="setFilterChip('STATIC')"
        (keydown.space)="$event.preventDefault(); setFilterChip('STATIC')"
        [attr.aria-label]="'Static and utility: ' + staticCount + ' measurements'"
      >
        <div class="card-top-row">
          <div class="kpi-icon-wrap icon-static">
            <svg class="kpi-svg-icon static-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2v-4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="kpi-title-block">
            <span class="kpi-label">Static and utility</span>
            <span class="kpi-value val-static">{{ staticCount }}</span>
          </div>
        </div>

        <div class="card-bottom-row static-bar-container">
          <div class="mini-bar-chart" aria-hidden="true">
            <div class="bar-column" *ngFor="let col of getMaintenanceStaticBreakdown()">
              <div class="bar-slot">
                <div class="bar-rect" [style.height.%]="col.heightPct" [class.is-zero]="col.count === 0"></div>
              </div>
              <span class="bar-col-label">{{ col.shortName }}</span>
            </div>
          </div>
          <div class="static-subtext">Bill-based, not live monitored</div>
        </div>
      </div>
    </div>

    <!-- 3. Compact Filter Bar -->
    <div class="kpi-filter-toolbar">
      <!-- Filter Chips -->
      <div class="filter-chips-group">
        <button
          type="button"
          class="filter-chip"
          [class.active]="activeFilterChip === 'ALL'"
          (click)="setFilterChip('ALL')"
        >
          <span class="chip-label">All</span>
          <span class="chip-count">{{ totalCount + staticCount }}</span>
        </button>

        <button
          type="button"
          class="filter-chip chip-warning"
          [class.active]="activeFilterChip === 'NEEDS_ATTENTION'"
          (click)="setFilterChip('NEEDS_ATTENTION')"
        >
          <span class="chip-dot warning-dot" *ngIf="warningCount > 0"></span>
          <span class="chip-label">Needs Attention</span>
          <span class="chip-count">{{ warningCount }}</span>
        </button>

        <button
          type="button"
          class="filter-chip chip-healthy"
          [class.active]="activeFilterChip === 'HEALTHY'"
          (click)="setFilterChip('HEALTHY')"
        >
          <span class="chip-label">Working Normally</span>
          <span class="chip-count">{{ healthyCount }}</span>
        </button>

        <button
          type="button"
          class="filter-chip chip-static"
          [class.active]="activeFilterChip === 'STATIC'"
          (click)="setFilterChip('STATIC')"
          *ngIf="staticCount > 0"
        >
          <span class="chip-label">Static &amp; Utility</span>
          <span class="chip-count">{{ staticCount }}</span>
        </button>
      </div>

      <!-- Quick Search & Actions -->
      <div class="toolbar-actions">
        <div class="search-input-wrapper">
          <svg class="search-svg-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"/>
          </svg>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (ngModelChange)="applyFilters()"
            placeholder="Search meters, types, issues..."
            aria-label="Search meters"
          />
          <button
            type="button"
            class="clear-search-btn"
            *ngIf="searchTerm"
            (click)="searchTerm = ''; applyFilters()"
          >
            &times;
          </button>
        </div>

        <button type="button" class="btn-reset" *ngIf="hasActiveFilters" (click)="resetFilters()">
          Reset
        </button>

        <button
          type="button"
          class="btn-export-csv"
          [disabled]="filteredLoggers.length === 0"
          (click)="exportToCsv()"
          title="Export CSV"
        >
          <svg class="btn-svg-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
          <span>Export CSV</span>
        </button>
      </div>
    </div>

    <!-- Active Contributor Filter Banner (if drilldown active) -->
    <div class="contributor-filter-bar" *ngIf="activeContributorFilterIds">
      <span>Filtered by contributors to: <strong>{{ activeContributorParentName }}</strong></span>
      <button type="button" class="btn-clear-contributor" (click)="clearContributorFilter()">Show all meters</button>
    </div>

    <!-- Empty filtered results -->
    <div class="empty-results-box" *ngIf="filteredLoggers.length === 0">
      <svg class="empty-svg-icon" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"/>
      </svg>
      <h4>No meters found</h4>
      <p>No physical meters match your active search or filters.</p>
      <button type="button" class="btn-reset" (click)="resetFilters()">Clear Filters</button>
    </div>

    <!-- SECTION 1: NEEDS ATTENTION (Warm Amber / Peach container) -->
    <div class="issue-section-container needs-attention-tinted-container" *ngIf="needsAttentionMeters.length > 0">
      <div class="section-heading heading-needs-attention" (click)="toggleNeedsAttentionSection()" tabindex="0" (keydown.enter)="toggleNeedsAttentionSection()" (keydown.space)="$event.preventDefault(); toggleNeedsAttentionSection()">
        <div class="heading-left">
          <div class="heading-icon-wrap icon-wrap-warn">
            <svg class="heading-svg-icon icon-warn" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="heading-text-group">
            <div class="heading-title-line">
              <h3>Needs Attention</h3>
              <span class="count-pill pill-warning">{{ needsAttentionMeters.length }} {{ needsAttentionMeters.length === 1 ? 'meter' : 'meters' }}</span>
            </div>
            <div class="heading-sub">Requires investigation or hardware review</div>
          </div>
        </div>
        <div class="heading-right">
          <button
            type="button"
            class="btn-section-chevron"
            [class.rotated]="!needsAttentionSectionExpanded"
            (click)="$event.stopPropagation(); toggleNeedsAttentionSection()"
            [attr.aria-label]="needsAttentionSectionExpanded ? 'Collapse Needs Attention' : 'Expand Needs Attention'"
            [title]="needsAttentionSectionExpanded ? 'Collapse Needs Attention' : 'Expand Needs Attention'"
          >
            <svg class="section-chevron-svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="meter-cards-stack" *ngIf="needsAttentionSectionExpanded">
        <div
          class="modern-meter-card card-alert"
          *ngFor="let meter of needsAttentionMeters"
          [class.drawer-open]="meter.detailsExpanded"
        >
          <!-- Card Main Header / Row -->
          <div
            class="card-summary-row"
            (click)="toggleDetails(meter)"
            tabindex="0"
            (keydown.enter)="toggleDetails(meter)"
            (keydown.space)="$event.preventDefault(); toggleDetails(meter)"
          >
            <!-- Left Info Block with Resource Tile -->
            <div class="summary-left">
              <div class="resource-tile" [ngClass]="getResourceTypeClass(meter.type)">
                <!-- Electricity -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-electricity'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                </svg>
                <!-- Gas -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-gas'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z"/>
                </svg>
                <!-- Water -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-water'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/>
                </svg>
                <!-- Solar -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-solar'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="4"/>
                  <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
                </svg>
                <!-- Heat -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-heat'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 14.76V3.5a2.5 2.5 0 00-5 0v11.26a4.5 4.5 0 105 0z"/>
                </svg>
                <!-- Oil -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-oil'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2v4m0 0a4 4 0 00-4 4v8a4 4 0 008 0v-8a4 4 0 00-4-4z"/>
                </svg>
                <!-- Biomass -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-biomass'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 20A7 7 0 019.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/>
                  <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
                </svg>
                <!-- Sensors -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-sensors'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 20a8 8 0 100-16 8 8 0 000 16z"/>
                  <path d="M12 14a2 2 0 100-4 2 2 0 000 4z"/>
                  <path d="M12 2v2m0 16v2M2 12h2m16 0h2"/>
                </svg>
                <!-- General / Default -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-general' || getResourceTypeClass(meter.type) === 'res-default'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <path d="M7 12h10M12 7v10"/>
                </svg>
              </div>

              <div class="meter-info-column">
                <div class="title-and-badges">
                  <span class="resource-pill" [ngClass]="getResourceTypeClass(meter.type)">
                    <span class="res-text">{{ meter.type }}</span>
                  </span>
                  <span class="meter-display-name">{{ meter.meterName }}</span>
                  <span class="status-badge-chip badge-warning">
                    {{ meter.status }}
                  </span>
                </div>
                <div class="meter-plain-message">
                  {{ meter.message }}
                </div>
              </div>
            </div>

            <!-- Right Telemetry Metrics Block with Visual Dividers -->
            <div class="summary-right">
              <div class="metric-block reading-block">
                <div class="block-label-row">
                  <svg class="block-icon-svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clip-rule="evenodd"/>
                  </svg>
                  <span class="block-label">Latest Reading</span>
                </div>
                <div class="block-value" *ngIf="meter.latestValue !== null && meter.latestValue !== undefined">
                  {{ getLatestValueDisplay(meter) }}
                </div>
                <div class="block-placeholder" *ngIf="meter.latestValue === null || meter.latestValue === undefined">
                  &mdash;
                </div>
              </div>

              <div class="metric-block-divider"></div>

              <div class="metric-block freshness-block">
                <div class="freshness-header">
                  <div class="block-label-row">
                    <svg class="block-icon-svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"/>
                    </svg>
                    <span class="block-label">Data Received</span>
                  </div>
                  <span class="freshness-badge" [ngClass]="getFreshnessPill(meter).class">
                    {{ getFreshnessPill(meter).label }}
                  </span>
                </div>
                <div class="freshness-relative">{{ getDataAge(meter) }}</div>
                <div class="freshness-timestamp">
                  {{ meter.lastReading ? (meter.lastReading | date:'yyyy-MM-dd HH:mm') : '&mdash;' }}
                </div>
              </div>

              <div class="metric-block-divider"></div>

              <div class="metric-block channels-block">
                <div class="block-label-row">
                  <svg class="block-icon-svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"/>
                  </svg>
                  <span class="block-label">Channels</span>
                </div>
                <span class="channels-badge" [title]="meter.coverageDiagnostic || ''">
                  {{ meter.underlyingMeasurements?.length || 1 }} {{ (meter.underlyingMeasurements?.length || 1) === 1 ? 'channel' : 'channels' }}
                </span>
              </div>

              <div class="metric-block-divider"></div>

              <div class="metric-block action-block">
                <button
                  type="button"
                  class="btn-drawer-expand"
                  [class.open]="meter.detailsExpanded"
                  (click)="$event.stopPropagation(); toggleDetails(meter)"
                  title="Toggle measurements"
                >
                  <span class="expand-text">{{ meter.detailsExpanded ? 'Hide' : 'Measurements' }}</span>
                  <span class="expand-chevron" [class.rotated]="meter.detailsExpanded">&#9662;</span>
                </button>
                <button
                  type="button"
                  class="btn-circle-chevron"
                  [class.rotated]="meter.detailsExpanded"
                  (click)="$event.stopPropagation(); toggleDetails(meter)"
                  [title]="meter.detailsExpanded ? 'Collapse' : 'Expand'"
                >
                  <svg class="circle-chevron-svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Drawer for Underlying Measurements & Technical Diagnostics -->
          <div class="card-measurements-drawer" *ngIf="meter.detailsExpanded">
            <div class="drawer-content">
              <div class="drawer-top-bar">
                <div class="drawer-title">
                  Underlying Measurements ({{ meter.underlyingMeasurements?.length || 0 }})
                </div>
                <button
                  type="button"
                  class="btn-tech-toggle"
                  *ngIf="isSuperAdmin"
                  (click)="toggleTechnicalDrawer(meter, $event)"
                >
                  {{ meter.supportDetailsExpanded ? 'Hide Technical Diagnostics' : 'Show Technical Diagnostics' }}
                </button>
              </div>

              <!-- Measurements Table -->
              <div class="clean-table-wrapper" *ngIf="meter.underlyingMeasurements && meter.underlyingMeasurements.length > 0">
                <table class="saas-table">
                  <thead>
                    <tr>
                      <th>Measurement</th>
                      <th>Reading Type</th>
                      <th>Latest Reading</th>
                      <th>Status</th>
                      <th>Last Recorded</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let ch of meter.underlyingMeasurements">
                      <td class="col-name"><strong>{{ ch.name }}</strong></td>
                      <td class="col-type">{{ ch.readingType || 'Measurement' }}</td>
                      <td class="col-reading">
                        <span *ngIf="ch.latestValue !== null && ch.latestValue !== undefined">
                          {{ ch.latestValue | number:'1.0-2' }} {{ ch.unit }}
                        </span>
                        <span *ngIf="ch.latestValue === null || ch.latestValue === undefined">&mdash;</span>
                      </td>
                      <td class="col-status">
                        <span
                          class="channel-status-pill"
                          [class.status-pill-healthy]="ch.status === 'Healthy'"
                          [class.status-pill-warning]="ch.status !== 'Healthy' && ch.status !== 'Unmonitored'"
                          [class.status-pill-unmonitored]="ch.status === 'Unmonitored'"
                        >
                          {{ ch.status }}
                        </span>
                      </td>
                      <td class="col-time">
                        {{ ch.lastReading ? (ch.lastReading | date:'yyyy-MM-dd HH:mm') : '&mdash;' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- SuperAdmin Isolated Technical Diagnostics -->
              <div class="superadmin-diagnostics-box" *ngIf="isSuperAdmin && meter.supportDetailsExpanded">
                <div class="diagnostics-header">
                  <svg class="diag-lock-svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/>
                  </svg>
                  <span>SuperAdmin Diagnostics (Internal Only)</span>
                </div>
                <div class="diagnostics-grid">
                  <div class="diag-pair">
                    <span class="diag-key">Physical Device Key:</span>
                    <span class="diag-val">{{ meter.physicalDeviceKey || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Vendor Type:</span>
                    <span class="diag-val">{{ meter.vendorType || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Gateway Key:</span>
                    <span class="diag-val">{{ meter.gatewayKey || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Device String:</span>
                    <span class="diag-val">{{ meter.deviceString || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Coverage:</span>
                    <span class="diag-val">{{ meter.coverageDiagnostic || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Failure Stage:</span>
                    <span class="diag-val">{{ meter.suspectedFailureStage || 'None' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Raw Channels:</span>
                    <span class="diag-val">{{ meter.channels?.length || 0 }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Status Evaluated:</span>
                    <span class="diag-val">{{ meter.lastUpdated ? (meter.lastUpdated | date:'yyyy-MM-dd HH:mm:ss') : '&mdash;' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SECTION 2: WORKING NORMALLY (Collapsible) -->
    <div class="issue-section-container working-normally-container" *ngIf="healthyMeters.length > 0">
      <div
        class="section-heading heading-healthy collapsible-header"
        (click)="toggleHealthySection()"
        tabindex="0"
        (keydown)="onHealthyHeaderKeydown($event)"
      >
        <div class="heading-left">
          <div class="heading-icon-wrap icon-wrap-healthy">
            <svg class="heading-svg-icon icon-check" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="heading-text-group">
            <div class="heading-title-line">
              <h3>Working Normally</h3>
              <span class="count-pill pill-healthy">{{ healthyMeters.length }} {{ healthyMeters.length === 1 ? 'meter' : 'meters' }}</span>
            </div>
            <div class="heading-sub">Meters transmitting normally</div>
          </div>
        </div>
        <div class="heading-right">
          <button
            type="button"
            class="btn-section-chevron"
            [class.rotated]="!healthySectionExpanded"
            (click)="$event.stopPropagation(); toggleHealthySection()"
            [attr.aria-label]="healthySectionExpanded ? 'Collapse Working Normally' : 'Expand Working Normally'"
            [title]="healthySectionExpanded ? 'Collapse Working Normally' : 'Expand Working Normally'"
          >
            <svg class="section-chevron-svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Healthy Meters List -->
      <div class="meter-cards-stack" *ngIf="healthySectionExpanded">
        <div
          class="modern-meter-card card-healthy"
          *ngFor="let meter of healthyMeters"
          [class.drawer-open]="meter.detailsExpanded"
        >
          <!-- Card Main Header / Row -->
          <div
            class="card-summary-row"
            (click)="toggleDetails(meter)"
            tabindex="0"
            (keydown.enter)="toggleDetails(meter)"
            (keydown.space)="$event.preventDefault(); toggleDetails(meter)"
          >
            <!-- Left Info Block with Resource Tile -->
            <div class="summary-left">
              <div class="resource-tile" [ngClass]="getResourceTypeClass(meter.type)">
                <!-- Electricity -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-electricity'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                </svg>
                <!-- Gas -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-gas'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z"/>
                </svg>
                <!-- Water -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-water'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/>
                </svg>
                <!-- Solar -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-solar'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="4"/>
                  <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
                </svg>
                <!-- Heat -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-heat'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 14.76V3.5a2.5 2.5 0 00-5 0v11.26a4.5 4.5 0 105 0z"/>
                </svg>
                <!-- Oil -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-oil'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2v4m0 0a4 4 0 00-4 4v8a4 4 0 008 0v-8a4 4 0 00-4-4z"/>
                </svg>
                <!-- Biomass -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-biomass'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 20A7 7 0 019.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/>
                  <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
                </svg>
                <!-- Sensors -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-sensors'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 20a8 8 0 100-16 8 8 0 000 16z"/>
                  <path d="M12 14a2 2 0 100-4 2 2 0 000 4z"/>
                  <path d="M12 2v2m0 16v2M2 12h2m16 0h2"/>
                </svg>
                <!-- General / Default -->
                <svg *ngIf="getResourceTypeClass(meter.type) === 'res-general' || getResourceTypeClass(meter.type) === 'res-default'" class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <path d="M7 12h10M12 7v10"/>
                </svg>
              </div>

              <div class="meter-info-column">
                <div class="title-and-badges">
                  <span class="resource-pill" [ngClass]="getResourceTypeClass(meter.type)">
                    <span class="res-text">{{ meter.type }}</span>
                  </span>
                  <span class="meter-display-name">{{ meter.meterName }}</span>
                  <span class="status-badge-chip badge-healthy">
                    Healthy
                  </span>
                </div>
                <div class="meter-plain-message">
                  {{ meter.message }}
                </div>
              </div>
            </div>

            <!-- Right Telemetry Metrics Block with Visual Dividers -->
            <div class="summary-right">
              <div class="metric-block reading-block">
                <div class="block-label-row">
                  <svg class="block-icon-svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clip-rule="evenodd"/>
                  </svg>
                  <span class="block-label">Latest Reading</span>
                </div>
                <div class="block-value" *ngIf="meter.latestValue !== null && meter.latestValue !== undefined">
                  {{ getLatestValueDisplay(meter) }}
                </div>
                <div class="block-placeholder" *ngIf="meter.latestValue === null || meter.latestValue === undefined">
                  &mdash;
                </div>
              </div>

              <div class="metric-block-divider"></div>

              <div class="metric-block freshness-block">
                <div class="freshness-header">
                  <div class="block-label-row">
                    <svg class="block-icon-svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"/>
                    </svg>
                    <span class="block-label">Data Received</span>
                  </div>
                  <span class="freshness-badge" [ngClass]="getFreshnessPill(meter).class">
                    {{ getFreshnessPill(meter).label }}
                  </span>
                </div>
                <div class="freshness-relative">{{ getDataAge(meter) }}</div>
                <div class="freshness-timestamp">
                  {{ meter.lastReading ? (meter.lastReading | date:'yyyy-MM-dd HH:mm') : '&mdash;' }}
                </div>
              </div>

              <div class="metric-block-divider"></div>

              <div class="metric-block channels-block">
                <div class="block-label-row">
                  <svg class="block-icon-svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"/>
                  </svg>
                  <span class="block-label">Channels</span>
                </div>
                <span class="channels-badge" [title]="meter.coverageDiagnostic || ''">
                  {{ meter.underlyingMeasurements?.length || 1 }} {{ (meter.underlyingMeasurements?.length || 1) === 1 ? 'channel' : 'channels' }}
                </span>
              </div>

              <div class="metric-block-divider"></div>

              <div class="metric-block action-block">
                <button
                  type="button"
                  class="btn-drawer-expand"
                  [class.open]="meter.detailsExpanded"
                  (click)="$event.stopPropagation(); toggleDetails(meter)"
                  title="Toggle measurements"
                >
                  <span class="expand-text">{{ meter.detailsExpanded ? 'Hide' : 'Measurements' }}</span>
                  <span class="expand-chevron" [class.rotated]="meter.detailsExpanded">&#9662;</span>
                </button>
                <button
                  type="button"
                  class="btn-circle-chevron"
                  [class.rotated]="meter.detailsExpanded"
                  (click)="$event.stopPropagation(); toggleDetails(meter)"
                  [title]="meter.detailsExpanded ? 'Collapse' : 'Expand'"
                >
                  <svg class="circle-chevron-svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Drawer for Underlying Measurements & Technical Diagnostics -->
          <div class="card-measurements-drawer" *ngIf="meter.detailsExpanded">
            <div class="drawer-content">
              <div class="drawer-top-bar">
                <div class="drawer-title">
                  Underlying Measurements ({{ meter.underlyingMeasurements?.length || 0 }})
                </div>
                <button
                  type="button"
                  class="btn-tech-toggle"
                  *ngIf="isSuperAdmin"
                  (click)="toggleTechnicalDrawer(meter, $event)"
                >
                  {{ meter.supportDetailsExpanded ? 'Hide Technical Diagnostics' : 'Show Technical Diagnostics' }}
                </button>
              </div>

              <!-- Measurements Table -->
              <div class="clean-table-wrapper" *ngIf="meter.underlyingMeasurements && meter.underlyingMeasurements.length > 0">
                <table class="saas-table">
                  <thead>
                    <tr>
                      <th>Measurement</th>
                      <th>Reading Type</th>
                      <th>Latest Reading</th>
                      <th>Status</th>
                      <th>Last Recorded</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let ch of meter.underlyingMeasurements">
                      <td class="col-name"><strong>{{ ch.name }}</strong></td>
                      <td class="col-type">{{ ch.readingType || 'Measurement' }}</td>
                      <td class="col-reading">
                        <span *ngIf="ch.latestValue !== null && ch.latestValue !== undefined">
                          {{ ch.latestValue | number:'1.0-2' }} {{ ch.unit }}
                        </span>
                        <span *ngIf="ch.latestValue === null || ch.latestValue === undefined">&mdash;</span>
                      </td>
                      <td class="col-status">
                        <span
                          class="channel-status-pill"
                          [class.status-pill-healthy]="ch.status === 'Healthy'"
                          [class.status-pill-warning]="ch.status !== 'Healthy' && ch.status !== 'Unmonitored'"
                          [class.status-pill-unmonitored]="ch.status === 'Unmonitored'"
                        >
                          {{ ch.status }}
                        </span>
                      </td>
                      <td class="col-time">
                        {{ ch.lastReading ? (ch.lastReading | date:'yyyy-MM-dd HH:mm') : '&mdash;' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- SuperAdmin Isolated Technical Diagnostics -->
              <div class="superadmin-diagnostics-box" *ngIf="isSuperAdmin && meter.supportDetailsExpanded">
                <div class="diagnostics-header">
                  <svg class="diag-lock-svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/>
                  </svg>
                  <span>SuperAdmin Diagnostics (Internal Only)</span>
                </div>
                <div class="diagnostics-grid">
                  <div class="diag-pair">
                    <span class="diag-key">Physical Device Key:</span>
                    <span class="diag-val">{{ meter.physicalDeviceKey || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Vendor Type:</span>
                    <span class="diag-val">{{ meter.vendorType || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Gateway Key:</span>
                    <span class="diag-val">{{ meter.gatewayKey || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Device String:</span>
                    <span class="diag-val">{{ meter.deviceString || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Coverage:</span>
                    <span class="diag-val">{{ meter.coverageDiagnostic || '&mdash;' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Failure Stage:</span>
                    <span class="diag-val">{{ meter.suspectedFailureStage || 'None' }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Raw Channels:</span>
                    <span class="diag-val">{{ meter.channels?.length || 0 }}</span>
                  </div>
                  <div class="diag-pair">
                    <span class="diag-key">Status Evaluated:</span>
                    <span class="diag-val">{{ meter.lastUpdated ? (meter.lastUpdated | date:'yyyy-MM-dd HH:mm:ss') : '&mdash;' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SECTION 3: STATIC & UTILITY BILL MEASUREMENTS -->
    <div class="issue-section-container static-tinted-container" *ngIf="staticMetersList.length > 0">
      <div class="section-heading heading-static" (click)="toggleStaticSection()" tabindex="0" (keydown.enter)="toggleStaticSection()" (keydown.space)="$event.preventDefault(); toggleStaticSection()">
        <div class="heading-left">
          <div class="heading-icon-wrap icon-wrap-static">
            <svg class="heading-svg-icon icon-static" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="heading-text-group">
            <div class="heading-title-line">
              <h3>Static &amp; Utility</h3>
              <span class="count-pill pill-static">{{ staticMetersList.length }} {{ staticMetersList.length === 1 ? 'measurement' : 'measurements' }}</span>
            </div>
            <div class="heading-sub">Manual, reference or bill-based sources</div>
          </div>
        </div>
        <div class="heading-right">
          <button
            type="button"
            class="btn-section-chevron"
            [class.rotated]="!staticSectionExpanded"
            (click)="$event.stopPropagation(); toggleStaticSection()"
            [attr.aria-label]="staticSectionExpanded ? 'Collapse Static & Utility' : 'Expand Static & Utility'"
            [title]="staticSectionExpanded ? 'Collapse Static & Utility' : 'Expand Static & Utility'"
          >
            <svg class="section-chevron-svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="meter-cards-stack" *ngIf="staticSectionExpanded">
        <div class="modern-meter-card card-static" *ngFor="let meter of staticMetersList">
          <div class="card-summary-row">
            <div class="summary-left">
              <div class="resource-tile" [ngClass]="getResourceTypeClass(meter.type)">
                <svg class="resource-tile-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <polyline points="10 9 9 9 8 9"/>
                </svg>
              </div>
              <div class="meter-info-column">
                <div class="title-and-badges">
                  <span class="resource-pill" [ngClass]="getResourceTypeClass(meter.type)">
                    <span class="res-text">{{ meter.type }}</span>
                  </span>
                  <span class="meter-display-name">{{ meter.meterName }}</span>
                  <span class="status-badge-chip badge-static">Static Data</span>
                </div>
                <div class="meter-plain-message">{{ meter.message }}</div>
              </div>
            </div>
            <div class="summary-right">
              <div class="metric-block reading-block">
                <div class="block-label-row">
                  <span class="block-label">Last Entered Value</span>
                </div>
                <div class="block-value" *ngIf="meter.latestValue !== null && meter.latestValue !== undefined">
                  {{ getLatestValueDisplay(meter) }}
                </div>
                <div class="block-placeholder" *ngIf="meter.latestValue === null || meter.latestValue === undefined">
                  &mdash;
                </div>
              </div>
              <div class="metric-block-divider"></div>
              <div class="metric-block freshness-block">
                <div class="freshness-header">
                  <span class="block-label">Entry Date</span>
                  <span class="freshness-badge freshness-static">Static</span>
                </div>
                <div class="freshness-relative">
                  {{ meter.lastReading ? (meter.lastReading | date:'yyyy-MM-dd') : 'Unrecorded' }}
                </div>
                <div class="freshness-timestamp">Not live monitored</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================================================= -->
  <!-- 2. GLOBAL SUPPORT VIEW (OPERATIONS CONSOLE + DETAIL PANEL)                -->
  <!-- ========================================================================= -->
  <div class="global-support-wrapper" *ngIf="!loading && !error && !showCustomerView">
    <!-- Summary KPI Cards -->
    <div class="summary-cards four-cards">
      <div
        class="card card-total"
        [class.selected-filter]="activeKpiFilter === 'TOTAL'"
        (click)="selectKpiFilter('TOTAL')"
        tabindex="0"
        (keydown.enter)="selectKpiFilter('TOTAL')"
        (keydown.space)="$event.preventDefault(); selectKpiFilter('TOTAL')"
      >
        <div class="kpi-content">
          <div class="kpi-label">Total loggers</div>
          <div class="kpi-value">{{ totalCount }}</div>
          <div class="kpi-sub">{{ isSupportScopeFiltered ? 'Current filters' : 'All sites' }}</div>
        </div>
        <svg class="kpi-ring" viewBox="0 0 44 44" role="img"
             [attr.aria-label]="formatSupportShare(totalCount) + ' of loggers'">
          <circle class="kpi-ring-track" cx="22" cy="22" r="17.5"/>
          <circle class="kpi-ring-arc" *ngIf="totalCount > 0" cx="22" cy="22" r="17.5" pathLength="100" transform="rotate(-90 22 22)"
                [attr.stroke-dasharray]="getSupportShare(totalCount) + ' 100'"/>
          <text class="kpi-ring-text" x="22" y="22">{{ totalCount > 0 ? '100%' : '0%' }}</text>
        </svg>
      </div>

      <div
        class="card card-healthy"
        [class.selected-filter]="activeKpiFilter === 'HEALTHY'"
        (click)="selectKpiFilter('HEALTHY')"
        tabindex="0"
        (keydown.enter)="selectKpiFilter('HEALTHY')"
        (keydown.space)="$event.preventDefault(); selectKpiFilter('HEALTHY')"
      >
        <div class="kpi-content">
          <div class="kpi-label">Healthy</div>
          <div class="kpi-value">{{ healthyCount }}</div>
          <div class="kpi-sub">of {{ totalCount }}</div>
        </div>
        <svg class="kpi-ring" viewBox="0 0 44 44" role="img"
             [attr.aria-label]="formatSupportShare(healthyCount) + ' of loggers'">
          <circle class="kpi-ring-track" cx="22" cy="22" r="17.5"/>
          <circle class="kpi-ring-arc" *ngIf="healthyCount > 0" cx="22" cy="22" r="17.5" pathLength="100" transform="rotate(-90 22 22)"
                [attr.stroke-dasharray]="getSupportShare(healthyCount) + ' 100'"/>
          <text class="kpi-ring-text" x="22" y="22">{{ formatSupportShare(healthyCount) }}</text>
        </svg>
      </div>

      <div
        class="card card-warning"
        [class.selected-filter]="activeKpiFilter === 'WARNING'"
        (click)="selectKpiFilter('WARNING')"
        tabindex="0"
        (keydown.enter)="selectKpiFilter('WARNING')"
        (keydown.space)="$event.preventDefault(); selectKpiFilter('WARNING')"
      >
        <div class="kpi-content">
          <div class="kpi-label">Offline / late</div>
          <div class="kpi-value">{{ warningCount }}</div>
          <div class="kpi-sub">of {{ totalCount }}</div>
        </div>
        <svg class="kpi-ring" viewBox="0 0 44 44" role="img"
             [attr.aria-label]="formatSupportShare(warningCount) + ' of loggers'">
          <circle class="kpi-ring-track" cx="22" cy="22" r="17.5"/>
          <circle class="kpi-ring-arc" *ngIf="warningCount > 0" cx="22" cy="22" r="17.5" pathLength="100" transform="rotate(-90 22 22)"
                [attr.stroke-dasharray]="getSupportShare(warningCount) + ' 100'"/>
          <text class="kpi-ring-text" x="22" y="22">{{ formatSupportShare(warningCount) }}</text>
        </svg>
      </div>

      <div
        class="card card-pipeline"
        [class.selected-filter]="activeKpiFilter === 'PIPELINE'"
        (click)="selectKpiFilter('PIPELINE')"
        tabindex="0"
        (keydown.enter)="selectKpiFilter('PIPELINE')"
        (keydown.space)="$event.preventDefault(); selectKpiFilter('PIPELINE')"
      >
        <div class="kpi-content">
          <div class="kpi-label">Pipeline issues</div>
          <div class="kpi-value">{{ pipelineCount }}</div>
          <div class="kpi-sub">of {{ totalCount }}</div>
        </div>
        <svg class="kpi-ring" viewBox="0 0 44 44" role="img"
             [attr.aria-label]="formatSupportShare(pipelineCount) + ' of loggers'">
          <circle class="kpi-ring-track" cx="22" cy="22" r="17.5"/>
          <circle class="kpi-ring-arc" *ngIf="pipelineCount > 0" cx="22" cy="22" r="17.5" pathLength="100" transform="rotate(-90 22 22)"
                [attr.stroke-dasharray]="getSupportShare(pipelineCount) + ' 100'"/>
          <text class="kpi-ring-text" x="22" y="22">{{ formatSupportShare(pipelineCount) }}</text>
        </svg>
      </div>
    </div>

    <!-- Filters Row -->
    <div class="filter-row">
      <div class="search-box">
        <div class="search-input-wrapper">
          <svg class="search-svg-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"/>
          </svg>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (ngModelChange)="applyFilters()"
            placeholder="Search by site, logger, meter, reg, TRV or gateway..."
          />
        </div>
      </div>

      <div class="select-box">
        <label for="vendorSelect">Vendor:</label>
        <select id="vendorSelect" [(ngModel)]="vendorFilter" (ngModelChange)="applyFilters()">
          <option value="ALL">All Vendors</option>
          <option value="EpiSensor">EpiSensor</option>
          <option value="ND Metering">ND Metering</option>
        </select>
      </div>

      <div class="select-box">
        <label for="statusSelect">Status:</label>
        <select id="statusSelect" [(ngModel)]="statusFilter" (ngModelChange)="onStatusFilterChange()">
          <option value="ALL">All Statuses</option>
          <option value="HEALTHY">Healthy</option>
          <option value="LATE">Late</option>
          <option value="OFFLINE">Offline</option>
          <option value="STUCK">Processing Stuck</option>
          <option value="IMPORTERROR">Import Error</option>
          <option value="AGGDELAYED">Aggregation Delayed</option>
          <option value="AGGMISSING">Aggregation Missing</option>
          <option value="FROZEN">Frozen Value</option>
          <option value="UNMAPPED">Unmapped</option>
        </select>
      </div>

      <div class="select-box">
        <label for="activitySelect">Activity Window:</label>
        <select id="activitySelect" [(ngModel)]="activityFilter" (ngModelChange)="applyFilters()">
          <option value="ALL">All devices</option>
          <option value="3">Last 3 months</option>
          <option value="6">Last 6 months</option>
          <option value="12">Last 12 months</option>
          <option value="24">Last 24 months</option>
        </select>
      </div>

      <button type="button" class="reset-btn" (click)="resetFilters()">Reset</button>
      <button
        type="button"
        class="export-btn btn-export-csv"
        [disabled]="filteredLoggers.length === 0"
        (click)="exportToCsv()"
      >
        <svg class="btn-svg-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
        <span>Export CSV</span>
      </button>
    </div>

    <!-- Operations Console Split Layout (Master Table + Right Contextual Panel) -->
    <div class="support-console-container" *ngIf="filteredLoggers.length > 0">
      <!-- Master Table on Left (~72-73% width) -->
      <div class="support-master-table-wrapper" [class.panel-open]="selectedSupportLogger !== null">
        <div class="support-table-scroll">
          <table class="support-console-table">
            <thead>
              <tr>
                <th class="col-select-header"></th>
                <th (click)="setSortColumn('siteName')" class="sortable" *ngIf="isGlobalView">
                  Site Name
                  <span class="sort-arrow" *ngIf="sortColumn === 'siteName'">{{ sortDirection === 'asc' ? '&#9650;' : '&#9660;' }}</span>
                </th>
                <th (click)="setSortColumn('sourceDeviceKey')" class="sortable">
                  Device Identifier
                  <span class="sort-arrow" *ngIf="sortColumn === 'sourceDeviceKey'">{{ sortDirection === 'asc' ? '&#9650;' : '&#9660;' }}</span>
                </th>
                <th (click)="setSortColumn('vendorType')" class="sortable">
                  Vendor
                  <span class="sort-arrow" *ngIf="sortColumn === 'vendorType'">{{ sortDirection === 'asc' ? '&#9650;' : '&#9660;' }}</span>
                </th>
                <th (click)="setSortColumn('currentStatus')" class="sortable">
                  Status
                  <span class="sort-arrow" *ngIf="sortColumn === 'currentStatus'">{{ sortDirection === 'asc' ? '&#9650;' : '&#9660;' }}</span>
                </th>
                <th (click)="setSortColumn('updatedDate')" class="sortable">
                  Last Data Received
                  <span class="sort-arrow" *ngIf="sortColumn === 'updatedDate'">{{ sortDirection === 'asc' ? '&#9650;' : '&#9660;' }}</span>
                </th>
                <th class="action-header">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let logger of filteredLoggers"
                [class.row-selected]="selectedSupportLogger === logger"
                (click)="selectSupportLogger(logger)"
                tabindex="0"
                (keydown.enter)="selectSupportLogger(logger)"
                (keydown.space)="$event.preventDefault(); selectSupportLogger(logger)"
              >
                <td class="col-select-cell">
                  <span class="row-select-bullet" [class.active]="selectedSupportLogger === logger"></span>
                </td>
                <td *ngIf="isGlobalView" class="col-site" [title]="logger.siteName || '[Unmapped]'">
                  <div class="site-main-text">{{ logger.siteName || '[Unmapped]' }}</div>
                  <div class="site-sub-meter" *ngIf="getFriendlyMeterSubtitle(logger)" [title]="getFriendlyMeterSubtitle(logger)">
                    {{ getFriendlyMeterSubtitle(logger) }}
                  </div>
                </td>
                <td class="col-device" [title]="logger.sourceDeviceKey || 'N/A'">
                  <code>{{ logger.sourceDeviceKey || 'N/A' }}</code>
                </td>
                <td class="col-vendor">
                  <div class="vendor-cell-wrap">
                    <span class="vendor-badge-initial" [class.vendor-badge-nd]="(logger.vendorType || '').toLowerCase().includes('nd')">{{ getVendorInitials(logger.vendorType) }}</span>
                    <span class="vendor-name-text">{{ logger.vendorType || 'Unknown' }}</span>
                  </div>
                </td>
                <td class="col-status">
                  <span
                    class="status-badge"
                    [class.status-healthy]="logger.currentStatus === 'Healthy'"
                    [class.status-late]="logger.currentStatus === 'Late'"
                    [class.status-offline]="logger.currentStatus === 'Offline'"
                    [class.status-processing-stuck]="logger.currentStatus === 'Processing Stuck'"
                    [class.status-import-error]="logger.currentStatus === 'Import Error'"
                    [class.status-aggregation-delayed]="logger.currentStatus === 'Aggregation Delayed'"
                    [class.status-unmapped]="logger.currentStatus === 'Unmapped'"
                    [class.status-frozen-value]="logger.currentStatus === 'Frozen Value'"
                    [class.status-aggregation-missing]="logger.currentStatus === 'Aggregation Missing'"
                  >
                    {{ logger.currentStatus }}
                  </span>
                </td>
                <td class="col-updated" [title]="logger.updatedDate ? (logger.updatedDate | date:'yyyy-MM-dd HH:mm:ss') : 'N/A'">
                  <div class="timestamp-main">{{ logger.updatedDate ? (logger.updatedDate | date:'yyyy-MM-dd HH:mm') : 'N/A' }}</div>
                  <div class="relative-age-sub">{{ getDataAge(logger) }}</div>
                </td>
                <td class="col-action">
                  <div class="action-buttons-group">
                    <button
                      type="button"
                      class="btn-icon-action"
                      (click)="inspectOverview(logger, $event)"
                      title="Overview"
                      aria-label="Overview"
                    >
                      <svg class="action-svg" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                        <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd"/>
                      </svg>
                    </button>
                    <button
                      type="button"
                      class="btn-icon-action"
                      (click)="inspectDiagnostics(logger, $event)"
                      title="Diagnostics"
                      aria-label="Diagnostics"
                    >
                      <svg class="action-svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Right Contextual Diagnostics Panel (~27-28% width) -->
      <div class="support-detail-panel" *ngIf="selectedSupportLogger">
        <div class="panel-header">
          <div class="panel-title-group">
            <div class="panel-eyebrow">{{ selectedSupportLogger.siteName || 'Site Device' }}</div>
            <h3 class="panel-title">{{ getMeterName(selectedSupportLogger) }}</h3>
          </div>
          <button type="button" class="btn-panel-close" (click)="closeSupportDetails()" title="Close panel" aria-label="Close panel">&times;</button>
        </div>

        <!-- Status Summary Bar -->
        <div class="panel-status-bar">
          <span
            class="status-badge"
            [class.status-healthy]="selectedSupportLogger.currentStatus === 'Healthy'"
            [class.status-late]="selectedSupportLogger.currentStatus === 'Late'"
            [class.status-offline]="selectedSupportLogger.currentStatus === 'Offline'"
            [class.status-processing-stuck]="selectedSupportLogger.currentStatus === 'Processing Stuck'"
            [class.status-import-error]="selectedSupportLogger.currentStatus === 'Import Error'"
            [class.status-aggregation-delayed]="selectedSupportLogger.currentStatus === 'Aggregation Delayed'"
            [class.status-unmapped]="selectedSupportLogger.currentStatus === 'Unmapped'"
            [class.status-frozen-value]="selectedSupportLogger.currentStatus === 'Frozen Value'"
            [class.status-aggregation-missing]="selectedSupportLogger.currentStatus === 'Aggregation Missing'"
          >
            {{ selectedSupportLogger.currentStatus }}
          </span>
          <span class="panel-relative-age">{{ getDataAge(selectedSupportLogger) }}</span>
        </div>

        <!-- Segmented Tabs for Panel -->
        <div class="panel-tabs">
          <button
            type="button"
            class="panel-tab-btn"
            [class.active]="activeSupportTab === 'OVERVIEW'"
            (click)="setSupportTab('OVERVIEW')"
          >
            Overview
          </button>
          <button
            type="button"
            class="panel-tab-btn"
            [class.active]="activeSupportTab === 'DIAGNOSTICS'"
            (click)="setSupportTab('DIAGNOSTICS')"
          >
            Diagnostics
          </button>
        </div>

        <!-- Panel Content Body -->
        <div class="panel-body">
          <!-- OVERVIEW TAB -->
          <div class="tab-pane" *ngIf="activeSupportTab === 'OVERVIEW'">
            <!-- Status & Failure Stage Card -->
            <div class="panel-card-block" *ngIf="selectedSupportLogger.suspectedFailureStage">
              <div class="block-header">
                <span class="block-title">Diagnostics Alert</span>
              </div>
              <div class="failure-stage-text">
                <strong>Failure Stage:</strong> {{ selectedSupportLogger.suspectedFailureStage }}
              </div>
            </div>

            <!-- Telemetry Milestones Timeline -->
            <div class="panel-card-block">
              <div class="block-header">
                <span class="block-title">Telemetry Milestones</span>
              </div>
              <div class="timeline-list">
                <div class="timeline-item" *ngIf="selectedSupportLogger.latestFileReceivedDate">
                  <div class="timeline-dot dot-blue"></div>
                  <div class="timeline-content">
                    <div class="timeline-label">Latest File Received</div>
                    <div class="timeline-val">{{ selectedSupportLogger.latestFileReceivedDate | date:'yyyy-MM-dd HH:mm:ss' }}</div>
                  </div>
                </div>
                <div class="timeline-item" *ngIf="selectedSupportLogger.latestRawReadingDate">
                  <div class="timeline-dot dot-green"></div>
                  <div class="timeline-content">
                    <div class="timeline-label">Latest Raw DB Reading</div>
                    <div class="timeline-val">{{ selectedSupportLogger.latestRawReadingDate | date:'yyyy-MM-dd HH:mm:ss' }}</div>
                  </div>
                </div>
                <div class="timeline-item" *ngIf="selectedSupportLogger.latestAggregatedReadingDate">
                  <div class="timeline-dot dot-violet"></div>
                  <div class="timeline-content">
                    <div class="timeline-label">Latest Aggregated DB Reading</div>
                    <div class="timeline-val">{{ selectedSupportLogger.latestAggregatedReadingDate | date:'yyyy-MM-dd HH:mm:ss' }}</div>
                  </div>
                </div>
                <div class="timeline-item" *ngIf="selectedSupportLogger.updatedDate">
                  <div class="timeline-dot dot-slate"></div>
                  <div class="timeline-content">
                    <div class="timeline-label">Status Evaluated Date</div>
                    <div class="timeline-val">{{ selectedSupportLogger.updatedDate | date:'yyyy-MM-dd HH:mm:ss' }}</div>
                  </div>
                </div>
                <div class="timeline-item" *ngIf="selectedSupportLogger.lastAlertSentDate">
                  <div class="timeline-dot dot-amber"></div>
                  <div class="timeline-content">
                    <div class="timeline-label">Last Alert Sent</div>
                    <div class="timeline-val">{{ selectedSupportLogger.lastAlertSentDate | date:'yyyy-MM-dd HH:mm:ss' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Device Identity Block -->
            <div class="panel-card-block">
              <div class="block-header">
                <span class="block-title">Device Identity</span>
              </div>
              <div class="diag-props-grid">
                <div class="diag-prop">
                  <span class="prop-k">Device Key:</span>
                  <span class="prop-v"><code>{{ selectedSupportLogger.sourceDeviceKey || '&mdash;' }}</code></span>
                </div>
                <div class="diag-prop">
                  <span class="prop-k">Vendor:</span>
                  <span class="prop-v">{{ selectedSupportLogger.vendorType || '&mdash;' }}</span>
                </div>
                <div class="diag-prop" *ngIf="selectedSupportLogger.gatewayKey">
                  <span class="prop-k">Gateway Key:</span>
                  <span class="prop-v">{{ selectedSupportLogger.gatewayKey }}</span>
                </div>
                <div class="diag-prop" *ngIf="selectedSupportLogger.deviceString">
                  <span class="prop-k">Device String:</span>
                  <span class="prop-v">{{ selectedSupportLogger.deviceString }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- DIAGNOSTICS TAB -->
          <div class="tab-pane" *ngIf="activeSupportTab === 'DIAGNOSTICS'">
            <div class="panel-card-block">
              <div class="block-header">
                <span class="block-title">Ingestion &amp; Register Parameters</span>
              </div>
              <div class="diag-props-grid">
                <div class="diag-prop">
                  <span class="prop-k">TRV ID:</span>
                  <span class="prop-v">{{ selectedSupportLogger.trvID || '&mdash;' }}</span>
                </div>
                <div class="diag-prop">
                  <span class="prop-k">Config Register (DEF ID):</span>
                  <span class="prop-v">{{ selectedSupportLogger.configRegister || '&mdash;' }}</span>
                </div>
                <div class="diag-prop">
                  <span class="prop-k">Reading Type:</span>
                  <span class="prop-v">{{ selectedSupportLogger.configReadingType || '&mdash;' }}</span>
                </div>
                <div class="diag-prop">
                  <span class="prop-k">Aggregation:</span>
                  <span class="prop-v">{{ selectedSupportLogger.configAggregation || '&mdash;' }}</span>
                </div>
                <div class="diag-prop">
                  <span class="prop-k">Value Scale:</span>
                  <span class="prop-v">{{ selectedSupportLogger.configValueScale ?? '&mdash;' }}</span>
                </div>
                <div class="diag-prop">
                  <span class="prop-k">Unit:</span>
                  <span class="prop-v">{{ selectedSupportLogger.configUnit || '&mdash;' }}</span>
                </div>
                <div class="diag-prop">
                  <span class="prop-k">Logger Name:</span>
                  <span class="prop-v">{{ selectedSupportLogger.loggerName || '&mdash;' }}</span>
                </div>
                <div class="diag-prop">
                  <span class="prop-k">Site ID:</span>
                  <span class="prop-v">{{ selectedSupportLogger.siteID || '&mdash;' }}</span>
                </div>
                <div class="diag-prop" *ngIf="selectedSupportLogger.healthStatusID">
                  <span class="prop-k">Health Status ID:</span>
                  <span class="prop-v">{{ selectedSupportLogger.healthStatusID }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty state view -->
    <div class="empty-state" *ngIf="filteredLoggers.length === 0">
      <svg class="empty-svg-icon" viewBox="0 0 20 20" fill="currentColor">
        <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"/>
      </svg>
      <h3 *ngIf="hasActiveFilters">No results match your active filters.</h3>
      <ng-container *ngIf="!hasActiveFilters">
        <h3 *ngIf="isGlobalView">No ingestion health records were returned for the all-sites support view.</h3>
        <h3 *ngIf="!isGlobalView">Health information is not currently available for the configured meters at this site.</h3>
      </ng-container>
    </div>
  </div>

  <!-- Review Confirmation Overlay Dialog -->
  <div class="review-overlay" *ngIf="activeReviewLogger" (click)="cancelReview()">
    <div class="review-dialog" (click)="$event.stopPropagation()">
      <h3>Confirm Classification</h3>
      <p class="review-message">
        Mark this measurement as Static / Bill-Based?
      </p>
      <p class="review-description">
        It will be treated as manually or bill updated and will no longer be evaluated as a live-monitored measurement.
      </p>

      <div class="review-progress" *ngIf="savingReview">
        <span class="spinner-small"></span>
        Saving configuration...
      </div>

      <div class="review-error-alert" *ngIf="reviewError">
        {{ reviewError }}
      </div>

      <div class="review-buttons">
        <button type="button" class="btn-cancel" [disabled]="savingReview" (click)="cancelReview()">Cancel</button>
        <button type="button" class="btn-confirm" [disabled]="savingReview" (click)="confirmReview()">Confirm Static</button>
      </div>
    </div>
  </div>
</div>
